import  request  from '../../Interceptor/request.js'

//获取全部信息
export function timeSwitch(data) {
    return request({
        url: '/order/list/time',
        method: 'get',
        params:data
    })
}

//月查询
export function orderContent(data) {
    return request({
        url: '/order/list',
        method: 'get',
        params:data
    })
}


export function orderTimeList(data) {
    return request({
        url: '/order/list/time',
        method: 'get',
        params:data
    })
}

